import {
    activeNavItemAtom,
    assistDemoModeAtom,
    auditDemoModeAtom,
    demoModeAtom,
    reportDemoModeAtom,
    userAtom
} from '@/global-store.jsx';
import NavBadge from '@/layout/NavBadge.jsx';
import LightTooltip from '@components/LightTooltip.jsx';
import { IconButton, List, Typography } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NavCollapse from './NavCollapse.jsx';
import NavItem from './NavItem.jsx';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

function NavGroup({ item }) {
    const [user] = useAtom(userAtom);
    const [reportDemoMode] = useAtom(reportDemoModeAtom);
    const [assistDemoMode] = useAtom(assistDemoModeAtom);
    const [auditDemoMode] = useAtom(auditDemoModeAtom);
    const [generalDemoMode] = useAtom(demoModeAtom);
    const [, setActiveNavItem] = useAtom(activeNavItemAtom);

    const { t } = useTranslation();

    const navigate = useNavigate();

    if (!user) {
        //console.error('User not found in NavGroup');
        return <></>;
    }

    // menu list collapse & items
    const items = item.children?.map(menu => {
        let allowed = menu.handle?.allowed;

        if (allowed) {
            if (!Array.isArray(allowed)) {
                allowed = [allowed];
            } else console.log('allowed', allowed);
            for (let allowedItem of allowed) {
                if (allowedItem === 'admin' && !user.isAdmin) return;
                if (allowedItem === 'salesAdmin' && !(user.isAdmin || user.isSalesAdmin)) return;
            }
        }

        const type = menu.handle?.type;
        if (type) {
            if (type === 'collapse')
                return (
                    <li key={menu.path}>
                        <NavCollapse key={menu.path} level={1} menu={menu} />
                    </li>
                );
            else if (type === 'item')
                return (
                    <li key={menu.path}>
                        <NavItem item={menu} level={1} />
                    </li>
                );
            else if (type === 'hidden') return null;
            else console.error('Unsupported value for route type:', type, 'Route:', menu);
        }
    });

    let allowed = item.handle?.allowed;
    if (allowed) {
        if (!Array.isArray(allowed)) {
            allowed = [allowed];
        }
        for (let allowedItem of allowed) {
            if (allowedItem === 'admin' && !user.isAdmin) return <></>;
            if (allowedItem === 'salesAdmin' && !(user.isAdmin || user.isSalesAdmin)) return <></>;
        }
    }

    let showBadge = false;
    if (item.handle?.badge) {
        if (item.handle.badge.showWhen === 'always') showBadge = true;
        else if (!generalDemoMode) {
            // dont show badges in demo mode
            if (item.handle.badge.showWhen === 'reportDemoMode' && reportDemoMode) showBadge = true;
            else if (item.handle.badge.showWhen === 'auditDemoMode' && auditDemoMode)
                showBadge = true;
            else if (item.handle.badge.showWhen === 'assistDemoMode' && assistDemoMode)
                showBadge = true;
        }
    }

    const GroupIcon = item.handle?.groupIcon?.icon;

    return (
        <List
            aria-labelledby={
                item.handle.i18nNameKey || item.handle.name
                    ? 'list-subheader-' + item.handle.i18nNameKey || item.handle.name
                    : null
            }
            className='no-print'
            component='ul'
            subheader={
                <>
                    {item.handle.i18nNameKey || item.handle.name ? (
                        <Typography
                            component='li'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                pr: '8px',
                                gap: 1.5
                            }}
                            variant='menuCaption'
                            //id={'list-subheader-' + item.handle.i18nNameKey || item.handle.name}
                            id={'list-subheader-' + item.path.replaceAll('/', '')}
                        >
                            {item.handle.i18nNameKey
                                ? t(item.handle.i18nNameKey)
                                : item.handle.name}

                            {item.handle.i18nCaptionKey ? (
                                <Typography variant='subMenuCaption'>
                                    {t(item.handle.i18nCaptionKey)}
                                </Typography>
                            ) : null}

                            {showBadge ? (
                                <NavBadge
                                    sx={{
                                        fontSize: '12px',
                                        mr: 1.25
                                    }}
                                    text={item.handle.badge.text}
                                />
                            ) : null}

                            {GroupIcon ? (
                                <LightTooltip
                                    placement='left'
                                    sx={{
                                        [`& .${tooltipClasses.tooltip}`]: {
                                            backgroundColor: '#fff !important',
                                            color: '#000 !important'
                                        }
                                    }}
                                    title={t(item.handle.groupIcon.i18nTooltipKey)}
                                >
                                    <IconButton
                                        color='white'
                                        onClick={() => {
                                            if (item.handle.groupIcon.to) {
                                                setActiveNavItem(item.path);
                                                return navigate(item.handle.groupIcon.to);
                                            } else console.log('No to in groupIcon');
                                        }}
                                        size='small'
                                        sx={{
                                            //ml: 'auto',
                                            'position': 'absolute',
                                            'right': '8px',
                                            'top': '0px',
                                            '& svg': {
                                                height: '1.57rem !important',
                                                width: '1.57rem !important'
                                            }
                                        }}
                                    >
                                        <GroupIcon />
                                    </IconButton>
                                </LightTooltip>
                            ) : null}
                        </Typography>
                    ) : null}
                </>
            }
            sx={{
                pb: 2
            }}
        >
            {items}
        </List>
    );
}

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
